import React from 'react';
import styles from './deviceGraphic.module.css';
import {deviceDetector} from '../../utils/deviceDetector';
import Markdown from 'markdown-to-jsx';
import {IDeviceGraphic} from '@dazn/lp-web/src/types/deviceGraphic.types';

interface DeviceGraphicProps {
    data: IDeviceGraphic;
    disableAnimation?: boolean;
}

const DeviceGraphic: React.FC<DeviceGraphicProps> = ({data}) => {
    const {title, description, image} = data || {};
    let imageUrl = image?.default;
    if (deviceDetector.isMobileDevice) {
        imageUrl = image?.mobile;
    }
    return (
        <div className={styles.deviceGraphicWrapper}>
            <div className={styles.wrap}>
                <img src={imageUrl} className={styles.image} />
                <div className={styles.copyWrapper}>
                    {title && (
                        <Markdown className={styles.title}>{title}</Markdown>
                    )}
                    {description && (
                        <Markdown className={styles.description}>
                            {description}
                        </Markdown>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DeviceGraphic;
